var formOperate = {
    data: function () {
        return {
            url:"",
            url_changestate:'',
            url_add:'',
            url_del:'',
            url_batch_delete:'',
            url_istop:'',
            url_post:'',
            url_index:'',
            url_post_excel: '',
            url_sort: '',
            url_init: '',

            //表格自定义编辑相关开始
            defaultGetList: true,
            show_edit_table: false,
            drag: false,
            editArray: [],
            tablehead: {
            },

            btnshow: true,//操作按钮是否显示

            // 筛选和分页
            pagination: {
                pagesize: 20, // 每页条数
                pageindex: 1, // 当前页码
                total: 0,
                hasmore: 0,
                search: { // 搜索
                    start_date: '',//开始时间
                    status: '', //状态
                    end_date: '',
                    title: '',//标题
                    area_code:"",
                    dept_id:'',
                },
                sortflag: { //排序条件
                }
            },

            //表单相关
            formName: 'listForm',
            formLoading: false,//表格提交状态
            formVisible: false,
            formShowResult: true,
            form: {},//表单数据
            excelForm:'excelForm',

            //弹窗抽屉相关
            showloading: false,//加载遮罩
            showdrawer: false,//显示抽屉
            showloadingtext: '加载中...',
            //单选
            selected: -1,
            //多选
            multiple: [],
            pageIndex: 1, // 弹窗索引
            activeId: -1, // 选中 id
            list: [],
            isLoadList: false,
            id: null,
            title: '新增',

            //日期控件配置
            pickerOptions: {
                // disabledDate(time) {
                //     // 禁用
                //     return time.getTime() > Date.now();
                // },
                shortcuts: [{
                    text: '今天',
                    onClick(picker) {
                        picker.$emit('pick', new Date());
                    }
                }, {
                    text: '昨天',
                    onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() - 3600 * 1000 * 24);
                        picker.$emit('pick', date);
                    }
                }, {
                    text: '一周前',
                    onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', date);
                    }
                }]
            },
            //日期控件配置（禁止跨月）
            pickerOptionsMonth: {
                shortcuts: [{
                    text: '今天',
                    onClick(picker) {
                        picker.$emit('pick', new Date());
                    }
                }, {
                    text: '昨天',
                    onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() - 3600 * 1000 * 24);
                        picker.$emit('pick', date);
                    }
                }, {
                    text: '一周前',
                    onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', date);
                    }
                }],


                onPick: ({ maxDate, minDate }) => {
                    this.selectData = minDate.getTime()
                    if (maxDate) {
                        this.selectData = ''
                    }
                },
                disabledDate: (time) => {
                    if (this.selectData) {
                        var date = new Date(this.selectData)
                        // 这里就是限制的关键，大于或者小于本月的日期被禁用
                        // 选择起始时间后，依旧需要判断禁止当天之后的时间
                        return date.getMonth() > new Date(time).getMonth() || date.getMonth() < new Date(time).getMonth() || time.getTime() > Date.now()
                    } else {
                        // 默认禁止当天之后的时间
                        return time.getTime() > Date.now();
                    }
                }
            },
            theme: {
                table: 'mini',
                search_form: '',
                edit_form: ''
            },
        }
    },
    watch: {
        'table.pagesize': function (newVal) {
            this.getList();
        },
        'table.pageindex': function (newVal) {
            this.getList();
        }
    },
    mounted: function () {
        // var _this = this;
        // if (this.defaultGetList) {
        //     this.getList();
        // }
        //
        // //表格自定义编辑相关开始
        // let pathname = encodeURIComponent(window.location.pathname);
        // if (localStorage.getItem(pathname)) {
        //     _this.editArray = JSON.parse(localStorage.getItem(pathname));
        //     _this.editArray.map(function (ele, index) {
        //         _this.tablehead[ele.name]['disabled'] = true;
        //     });
        // } else {
        //     Object.keys(this.tablehead).map(function (k, i) {
        //         // console.log({name:k,fixed:false,text:_this.tablehead[k].text})
        //         _this.editArray.push({
        //             name: k,
        //             fixed: _this.tablehead[k].fixed ? true : false,
        //             text: _this.tablehead[k].text,
        //             width: _this.tablehead[k].width
        //         });
        //         _this.tablehead[k]['disabled'] = true;
        //     });
        // }
        // //表格自定义编辑相关结束
    },
    methods: {
        // 封装ajax 请求
        fetch(url, data, method = "post") {
            return new Promise((resove, reject) => {
                $.ajax({
                    url: url,
                    data: data,
                    type: method,
                    dataType: "json",
                    success: (res) => {
                        resove(res)
                    },
                    fail: (err) => {
                        this.tableLoading = false
                        reject(err)
                    }
                });
            })
        },
        initPage() {
            this.showloading = true;
            $.ajax({
                url: this.url_init,
                dataType: 'json',
                method: 'get',
                success: (res) => {
                    this.showloading = false;
                    this.afterInitPage(res);
                },
                complete: function () {
                    this.showloading = false;
                }
            });
        },
        afterInitPage(res){},
        // 列表请求
        getList() {
            var _this = this;
            this.showloading = true;
            $.ajax({
                url: this.url,
                data: this.pagination,
                type: "post",
                dataType: "json",
                success: function (res) {
                    _this.isLoadList = false;
                    _this.list = [];
                    _this.multiple = [];//清空多选
                    _this.pagination.total = parseInt(res.total);
                    _this.$nextTick(()=>{
                        _this.list = res.tableData;
                        setTimeout(()=>{
                            _this.isLoadList = true;
                        },100);
                        if(res.total!=undefined){
                            _this.pagination.total = res.total;
                        }
                        if(res.hasmore!=undefined){
                            _this.pagination.hasmore = res.hasmore;
                        }
                        _this.showloading = false;//隐藏遮罩
                        // _this.initBtnWidth();
                        if(_this.afterGetList){
                            _this.afterGetList(res);
                        }
                    })
                },
                error: function () {
                    _this.showloading = false;
                    _this.$message.error('详情获取失败！请重试！');
                }
            });
        },

        // 统一跳转
        target(url) {
            window.location.href = url;
        },
        //搜索
        search() {
            var self = this;
            var start_date = self.pagination.search.start_date;
            var end_date = self.pagination.search.end_date;
            if (start_date) {
                self.pagination.search.start_date = CE.toolkit.elpickerDate(start_date);
            }
            if (end_date) {
                self.pagination.search.end_date = CE.toolkit.elpickerDate(end_date);
            }
            this.pagination.pageindex = 1;
            this.getList();
        },
        //导出
        exportExcel(e,domId) {
            console.log(domId)
            domId = domId ? domId : 'excelForm';
            let searchdata = this.pagination.search;
            Object.keys(searchdata).map(function (key, index) {
                let value = searchdata[key] ? searchdata[key] : '';
                $("#"+domId).append(`<input type="hidden" name="${key}" id="${key}" value="${value}" />`);
            });
            var excelForm = document.getElementById(domId);
            excelForm.submit();
        },
        //点击表格某一行行
        row_click(row) {
            this.selected = row.id;
        },
        //点击表格多选
        multiple_click(val) {
            console.log(val);
            this.multiple = val;
        },
        //排序
        sort_change(obj) {
            this.pagination.sortflag[obj.prop] = obj.order;
            this.getList()
        },
        //每页条数选择改变时
        handleSizeChange(val) {
            this.pagination.pagesize = val;
            this.pagination.pageindex = 1;
            this.getList()
        },
        //当前页码改变时
        handleCurrentChange(val) {
            this.pagination.pageindex = val;
            this.getList()
        },
        //删除
        del(id) {
            var _this = this;
            this.selected = id;
            if (this.selected != -1) {
                this.$confirm('确认要删除吗？', '确认信息', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '确认',
                    cancelButtonText: '取消'
                })
                .then(() => {
                    _this.showloading = true;
                    $.ajax({
                        url: this.url_del+"?id=" + _this.selected,
                        type: 'get',
                        dataType: "json",
                        success: function (data) {
                            _this.showloading = false;
                            if (data.code == 1) {
                                _this.getList();
                                _this.$message({
                                    message: data.msg,
                                    type: 'success'
                                });
                            } else {
                                _this.$message({
                                    message: data.msg,
                                    type: 'warning'
                                });
                            }
                        }, error: function () {
                            _this.showloading = false;
                            _this.$message.error('系统错误，请稍候重试');
                        }
                    })
                })
                .catch(action => {
                    //action === 'cancel'? '点取消': '点关闭'
                });
            } else {
                _this.$message('未选中数据');
            }
        },
        //批量删除
        batchDelete() {
            if (!this.multiple.length) {
                return this.$message.error('请至少选择一条数据！');
            }

            let ids = [];
            this.multiple.forEach(item => {
                ids.push(item.id);
            });
            this.$confirm('确认批量删除吗？', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {
                this.showloading = true;
                $.ajax({
                    url: this.url_batch_delete,
                    data: {ids: ids},
                    type: 'post',
                    success: (res) => {
                        this.showloading = false;
                        if (res.code == 1) {
                            this.multiple = [];
                            this.$refs.filterTable.clearSelection();
                            this.getList();
                            this.$message.success(res.msg);
                        } else {
                            this.$message.error(res.msg);
                        }
                    }, error: function () {
                        this.showloading = false;
                        this.$message.error('系统错误，请稍候重试');
                    }
                })
            }).catch(action => {
                //action === 'cancel'? '点取消': '点关闭'
            });
        },
        batchpass(type) {
            var _this = this;
            if (_this.multiple.length < 1) {
                this.$message.error('请至少选择一条数据！');
                return false;
            }

            if (type == -2) {
                _this.del();
                return;
            }

            if (type == 1) {
                if (selected_data[0]['status'] == 1) {
                    this.$message.error('当前数据已经是发布状态了!');
                    return false;
                }
                _this.release(status);
            }
            if (type == 2) {
                if (selected_data[0]['status'] == -1) {
                    this.$message.error('当前数据已经是撤销发布状态了!');
                    return false;
                }
                _this.release(status);
            }
            if (type == 3) {
                var selected_data = _this.multiple;
                var is_xtstatus = true;
                for (var i = 1, len = selected_data.length; i < len; i++) {
                    if (selected_data[i]['status'] !== selected_data[0]['status']) {
                        is_xtstatus = false;
                    }
                }
                if (is_xtstatus == false) {
                    this.$message.error('抱歉,只能对同一种状态的数据进行审核操作!');
                    return false;
                }
            }
        },
        //发布 撤销发布
        release(row,status,text) {
            var _this = this;
            this.selected = row.id;

            if (text == undefined) {
                text = row.status == '0' ? '发布' : '撤销发布';
            }
            this.$confirm('确认' + text + '吗？', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            })
            .then(() => {
                _this.showloading = true;
                $.ajax({
                    url: this.url_changestate,
                    type: 'post',
                    dataType: "json",
                    data: {'id': row.id, 'status': status},
                    success: function (data) {
                        _this.showloading = false;
                        if (data.code == 1) {
                            _this.getList();
                            _this.$message({
                                message: data.msg,
                                type: 'success'
                            });
                        } else {
                            _this.$message({
                                message: data.msg,
                                type: 'warning'
                            });
                        }
                    }, error: function () {
                        _this.showloading = false;
                        _this.$message.error('系统错误，请稍候重试');
                    }
                })
            })
            .catch(action => {
                //action === 'cancel'? '点取消': '点关闭'
            });
        },
        //置顶 取消置顶
        top(row) {
            var _this = this;
            this.selected = row.id;
            var msg = '';
            if (row.is_top == '0') {
                msg = '置顶';
            } else {
                msg = '取消置顶';
            }
            this.$confirm('确认要' + msg + '吗？', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            })
            .then(() => {
                _this.showloading = true;
                $.ajax({
                    url: this.url_istop,
                    type: 'post',
                    dataType: "json",
                    data: {'id': row.id, 'is_top': row.is_top},
                    success: function (data) {
                        _this.showloading = false;
                        if (data.code == 1) {
                            _this.getList();
                            _this.$message({
                                message: data.msg,
                                type: 'success'
                            });
                        } else {
                            _this.$message({
                                message: data.msg,
                                type: 'warning'
                            });
                        }
                    }, error: function () {
                        _this.showloading = false;
                        _this.$message.error('系统错误，请稍候重试');
                    }
                })
            })
            .catch(action => {
                //action === 'cancel'? '点取消': '点关闭'
            });
        },
        //精选 取消精选
        record(row) {
            var _this = this;
            this.selected = row.id;
            var msg = '';
            if (row.is_record == '0') {
                msg = '精选';
            } else {
                msg = '取消精选';
            }
            this.$confirm('确认要' + msg + '吗？', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            })
            .then(() => {
                _this.showloading = true;
                $.ajax({
                    url: this.url_isrecord,
                    type: 'post',
                    dataType: "json",
                    data: {'id': row.id, 'is_record': row.is_record},
                    success: function (data) {
                        _this.showloading = false;
                        if (data.code == 1) {
                            _this.getList();
                            _this.$message({
                                message: data.msg,
                                type: 'success'
                            });
                        } else {
                            _this.$message({
                                message: data.msg,
                                type: 'warning'
                            });
                        }
                    }, error: function () {
                        _this.showloading = false;
                        _this.$message.error('系统错误，请稍候重试');
                    }
                })
            })
            .catch(action => {
                //action === 'cancel'? '点取消': '点关闭'
            });
        },
        edit(tag) {
            var _this = this;
            _this.selected = tag;
            // 跳转编辑页
            window.location.href = this.url_add+"?id=" + _this.selected;
        },
        //表格自定义编辑相关开始
        addAt: function (name) {
            if (this.tablehead[name]['disabled']) {
                return;
            }
            this.tablehead[name]['disabled'] = true;
            this.editArray.push({name: name, fixed: false, text: this.tablehead[name].text});
            this.save_drag();
        },
        removeAt(idx) {
            let name = this.editArray[idx].name;
            this.tablehead[name]['disabled'] = false;
            this.editArray.splice(idx, 1);
            this.save_drag();
        },
        change_drag(e) {
            this.getList();
            this.save_drag();
        },
        save_drag() {
            let pathname = encodeURIComponent(window.location.pathname);
            localStorage.setItem(pathname, JSON.stringify(this.editArray))
        },
        reset() {
            let pathname = encodeURIComponent(window.location.pathname);
            localStorage.removeItem(pathname);
            window.location.reload();
        },
        //表格自定义编辑相关结束

        // 观察时间选择
        datePickerChange(e,type) {
            let start_date = e?e[0]:'';
            let end_date = e ? e[1] : '';
            this.pagination.search[type + 'start_date'] = start_date;
            this.pagination.search[type + 'end_date'] = end_date;
        },


        // 提交表单
        submitForm(formName) {
            var _this = this;

            this.$refs[formName].validate((valid) => {
                if (valid) {
                    _this.showloading = true;
                    // 表单提交
                    $.ajax({
                        url: _this.url_post,
                        data: _this.ruleForm,
                        dataType: 'json',
                        type: "post",
                        success: function (res) {
                            if (res.code == 1) {
                                _this.$message.success(res.msg);
                                if(_this.afterSubmitForm){
                                    _this.afterSubmitForm(res);
                                }
                                // 动画关闭需要一定的时间
                                setTimeout(() => {
                                    _this.showloading = false;//隐藏遮罩
                                    if (_this.url_index != undefined && _this.url_index) {
                                        window.location.href = _this.url_index;
                                    }
                                }, 400);
                            } else {
                                _this.$message.warning(res.msg);
                                _this.showloading = false;//隐藏遮罩
                            }
                        }, error: function () {
                            _this.showloading = false;//隐藏遮罩
                            document.querySelector('.el-main').scrollTop = _this.getErrorFieldOffsetTop(_this.$refs[formName])-200;
                            _this.$message.error('系统错误，请稍候重试');
                        }
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },

        showDrawer(){
            this.showdrawer = true;
            this.search();
        },

        getSystemConfigname(type, code,key) {
            for(var i=0;i<=system_config.length-1;i++){
                if(system_config[i]['type']==type&&system_config[i]['code']==code){

                    if(typeof(key)=='undefined'){
                        return system_config[i]['name'];
                    }else if(key=='all'){
                        return system_config[i];
                    }else{
                        return system_config[i][key];
                    }

                }
            }
            return '';
        },
        //列表操作栏宽度自适应
        initBtnWidth(){
            this.$nextTick(()=>{
                const opts = document.getElementsByClassName('autoMaxWidth');

                let widthArr = [];
                // 取操作组的最大宽度
                Array.prototype.forEach.call(opts, function (item) {
                    console.log(item);
                    if (item.innerText) {
                        widthArr.push(item.offsetWidth);
                    }
                });
                // 重新设置列标题及宽度属性
                let maxWidth = 200;
                if (widthArr.length > 0) {
                    maxWidth = Math.max(...widthArr) + 24;
                }
                this.$set(this.editArray[this.editArray.length - 1], 'width', maxWidth);
            })
        },

        //排序
        handleSort(id,sort){
            let _this = this;
            _this.showloading  = true;
            $.ajax({
                url: _this.url_sort,
                data: {'id': id, 'sort':sort},
                dataType: 'json',
                method: 'post',
                success: function (e){
                    if(e.code == 1){
                        _this.$message.success(e.msg);
                        _this.getList();
                    } else {
                        _this.$message.error(e.msg);
                    }
                    _this.showloading = false;
                },
                error: function (err){
                    _this.showloading = false;
                    _this.$message.error("请求错误");
                }
            })
        },

        //获取错误框的offsetTop
        getErrorFieldOffsetTop(elDom) {
            var errorElDom = elDom.fields.filter((item) => {
                return item.validateState === 'error';
            });
            var errorOffsetTops = errorElDom
            .map((item) => {
                return item.$el.offsetTop;
            })
            .sort();
            return errorOffsetTops[0];
        },
        // 表头部重新渲染
        renderHeader(h, { column, $index }) {
            let _this = this;
            if(!this.isLoadList){
                return;
            }
            // console.log(this.isLoadList);
            let id_name = column.property;
            // 获取操作按钮组的元素
            const opts = document.getElementsByClassName(id_name);
            // console.log(opts);
            let widthArr = [];
            // 取操作组的最大宽度
            Array.prototype.forEach.call(opts, function (item) {
                // console.log(item.offsetWidth);
                if (item.innerText) {
                    widthArr.push(item.offsetWidth);
                }
            });
            // 重新设置列标题及宽度属性
            if (widthArr.length > 0) {
                column.width = Math.max(...widthArr) + 24;
            } else {
                column.width = 0;
            }
            _this.$refs['filterTable'].doLayout();

            return h('span', column.label);
        },
    }
}

export default formOperate;



// WEBPACK FOOTER //
// ./src/utils/formOperate.js